import React from "react";
import HeroSection from "../components/HeroSection";
import ScrollingTicker from "../components/ScrollingTicker";
import AboutSection from "../components/AboutSection";
import SpecialDishSection from "../components/SpecialDishSection";
import TeamSection from "../components/TeamSection";
import WhyChooseUs from "../components/WhyChooseUs";
import AdvertisementBanner from "../components/AdvertisementBanner";
import MenuCategoriesSection from "../components/MenuCategoriesSection";
import TestimonialsSection from "../components/TestimonialsSection";
import FAQSection from "../components/FAQSection";
import BlogSection from "../components/BlogSection";
import FamilyRestaurantSection from "../components/FamilyRestaurantSection";

import SEO from "../components/SEO";
import { homePageSchema } from "../data/schemas";

const HomePage = () => {
  return (
    <div>
      <SEO
        title="Barbequeen | Best BBQ, Dum Biryani & Restaurant in Salem"
        metaTitle="Barbequeen | Best BBQ, Dum Biryani & Restaurant in Salem"
        description="Enjoy authentic double marinated grill chicken, wood-fire dum biryani, mandi & tandoori at Barbequeen Restaurant. Serving Salem & Tamil Nadu since 1999."
        keywords="Barbequeen restaurant, best biryani Salem, BBQ chicken Salem, dum biryani, grill chicken, tandoori restaurant Tamil Nadu, family dining Salem, mandi biryani"
        robots="index, follow"
        canonical="https://barbequeen.com/"
        og={{
          type: "website",
          url: "https://barbequeen.com/",
          title: "Barbequeen Restaurant | Authentic BBQ & Dum Biryani",
          description: "Enjoy authentic double marinated grill chicken, wood-fire dum biryani, mandi & tandoori at Barbequeen Restaurant. Serving Tamil Nadu since 1999.",
          image: "https://barbequeen.com/images/home-banner.jpg",
          siteName: "Barbequeen Restaurant",
          locale: "en_IN"
        }}
        geo={{
          region: "IN-TN",
          placename: "Tamil Nadu, India"
        }}
        schema={homePageSchema}
      />
      <HeroSection />
      <ScrollingTicker />
      <AboutSection />
      <SpecialDishSection />
      <TeamSection />
      <WhyChooseUs />
      <AdvertisementBanner />
      <MenuCategoriesSection />
      {/* <ReservationSection /> */}
      <TestimonialsSection />
      <FAQSection />
      <BlogSection />
      <FamilyRestaurantSection />
    </div>
  );
};

export default HomePage;
